import TransactionsData from './TransactionsData';

export default TransactionsData;
